module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": _vm.btnSize,
      "disabled": _vm.btnDisable,
      "icon": "el-icon-edit"
    },
    on: {
      "click": _vm.addCLassForStu
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "760",
      "footer-hide": ""
    },
    model: {
      value: (_vm.modalShow),
      callback: function($$v) {
        _vm.modalShow = $$v
      },
      expression: "modalShow"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "font-size": "15px"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-information-circle"
    }
  }), _vm._v(" "), _c('span', [_vm._t("default")], 2)], 1), _vm._v(" "), _c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.formStu,
      "label-width": "90px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "修改积分:"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formStu.score),
      callback: function($$v) {
        _vm.$set(_vm.formStu, "score", $$v)
      },
      expression: "formStu.score"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写备注"
    },
    model: {
      value: (_vm.formStu.remark),
      callback: function($$v) {
        _vm.$set(_vm.formStu, "remark", $$v)
      },
      expression: "formStu.remark"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#ccc",
      "margin-left": "20px"
    }
  }, [_vm._v("\n        *修改积分时，输入+增加积分，输入-减少积分\n      ")])], 1), _vm._v(" "), _c('Divider'), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "300px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.modalConfirm
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.modalCancel
    }
  }, [_vm._v("取消")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fcbbf204","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/componentsEdu/stuScore.vue
// module id = 734
// module chunks = 1